import React, { FC } from 'react';

import { Select } from 'chakra-react-select';
import { FormControl, FormLabel } from '@chakra-ui/react';

import { useGroups } from 'hooks';
import { useFormikContext } from 'formik';

import { GroupSelectProps } from './GroupSelect.props';

const GroupSelectView: FC<GroupSelectProps> = ({ values }) => {
  const { data, isLoading } = useGroups();
  const { setFieldValue, setFieldTouched } = useFormikContext<any>();

  const groups = data?.items || [];

  const options = groups.map((p) => ({ label: p.companyName, value: p._id }));

  const _values = values
    ? groups
        ?.filter((p) => values?.includes(p._id))
        ?.map((p) => ({ label: p.companyName, value: p._id }))
    : undefined;

  return (
    <FormControl mt={8}>
      <FormLabel
        htmlFor="groups"
        textTransform="capitalize"
        fontSize="12px"
        color="#afafaf">
        Groups
      </FormLabel>
      <Select
        isMulti
        value={_values}
        isDisabled={isLoading}
        isLoading={isLoading}
        options={options}
        tagVariant="solid"
        colorScheme="primary"
        closeMenuOnSelect={false}
        onBlur={() => setFieldTouched('groups', true)}
        chakraStyles={{
          dropdownIndicator: (_props) => ({
            ..._props,
            bg: 'transparent',
          }),
          option: (_props) => ({
            ..._props,
            padding: '10px',
            borderBottom: '1px solid #ccc',
          }),
          menuList: (_props) => ({
            ..._props,
            padding: '0px',
            marginBottom: '20px',
          }),
        }}
        onChange={(newValue) => {
          const _groups = newValue.map((n) => n.value);

          setFieldValue('groups', _groups);
        }}
      />
    </FormControl>
  );
};

export default GroupSelectView;
